export default (t) => [
    {
        route: 'users.index',
        label: t('navigation.users_index'),
        showInSidebar: true,
        permissions: ['user.admin']
    },
    {
        route: 'users.edit',
        label: t('navigation.users_profile'),
        showInSidebar: false
    },
    {
        route: 'roles.index',
        label: t('navigation.roles_index'),
        showInSidebar: true,
        permissions: ['user.admin'],
        children: [
            {
                route: 'roles.create',
                label: t('navigation.roles_create')
            },
            {
                route: 'roles.edit',
                label: t('navigation.roles_edit')
            }
        ]
    }
]
